import { createContext, SetStateAction, useContext, useState } from "react";

export interface PollingInfo {
  processId: string;
  accountGroupId: string;
  mlinkAccountId: string;
  mlinkId: string;
  passbookType: string;
  scrapeType?: number;
}


interface AccountPollingContextType {
  pollingInfos: PollingInfo[];
  setPollingInfos: React.Dispatch<SetStateAction<PollingInfo[]>>;
  addPollingInfo: (info: PollingInfo) => void;
  removePollingInfo: (processId: string) => void;
}

const AccountPollingContext = createContext<AccountPollingContextType | undefined>(undefined);

export const AccountPollingProvider = ({ children }: { children: React.ReactNode }) => {
  const [pollingInfos, setPollingInfos] = useState<PollingInfo[]>([]);

  const addPollingInfo = (info: PollingInfo) => {
    setPollingInfos((prev) => {
      // 送られてきたものを配列に追加する
      return [...prev, info];
    });
  };

  const removePollingInfo = (processId: string) => {
    setPollingInfos((prev) => {
      // processIdが一致しないものだけを残す
      return prev.filter(info => info.processId !== processId);
    });
  };

  return (
    <AccountPollingContext.Provider
      value={{
        pollingInfos,
        setPollingInfos,
        addPollingInfo,
        removePollingInfo,
      }}
    >
      {children}
    </AccountPollingContext.Provider>
  );
};

export const useAccountPollingContext = () => {
  const context = useContext(AccountPollingContext);
  if (!context) throw new Error("AccountPollingContext must be used within AccountPollingProvider");
  return context;
};